(ns ncr.etc.zustand
  (:require ["zustand" :refer [create] :rename {create createJSStore}]
            ["zustand/middleware" :refer [subscribeWithSelector shallow persist createJSONStorage]]
            [goog.object :as gobj]))

(defn clj->shallow [x]
  (let [m (js-obj)]
    (doseq [[k v] x]
      (gobj/set m (key->js k) v))
    m))

(defn js->shallow
  ([kf x]
   (persistent!
     (reduce (fn [r k] (assoc! r (kf k) (gobj/get x k)))
       (transient {}) (js-keys x))))
  ([x] (js->shallow keyword x)))

(defn get-keyword-fn [keyword-or-fn]
  (if (fn? keyword-or-fn)
    keyword-or-fn
    #(get % keyword-or-fn)))

(deftype Store [^js js-store]
  Object
  (get [_ f] (js-store (comp (if (fn? f) f #(map (fn [i] (i %)) f)) js->shallow)))
  (subscribe [_ s f] (.subscribe js-store (comp (get-keyword-fn s) js->shallow) f #js {:equalityFn shallow}))
  (setState [_ v] (.setState js-store (if (map? v) (clj->shallow v) (fn [s] (clj->shallow (v (js->shallow s)))))))
  (getState [_] (js->shallow (.getState js-store))))

(defn set-kv [f k]
  (fn [v] (f (hash-map k v))))

(defn- wrap-fn-result-or-value [fn-or-value]
  (if (fn? fn-or-value)
    (comp clj->shallow fn-or-value js->shallow)
    (clj->shallow fn-or-value)))

(defn- persist-if-required [f storage-id]
  (if storage-id (persist f (clj->js {:name storage-id})) f))

(defn create
  ([fun storage-id]
   (->
     (fn [st gt]
       (clj->shallow
         (fun (let [f (comp st wrap-fn-result-or-value)]
                {:f f
                 :p (partial set-kv f)
                 :g (comp js->shallow gt)
                 :fk (fn [k kf] (f #(hash-map k (kf (get % k)))))}))))
     (subscribeWithSelector)
     (persist-if-required storage-id)
     (createJSStore)
     (Store.)))
  ([fun]
   (create fun nil)))
